import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common.service';
import { Token } from '@angular/compiler';
import { Documento, AttachmentDto } from '../models/data.model';
import { DataService } from '../services/data.service';
import { MimetypeService } from '../services/mimetype.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-listini-vendita',
  templateUrl: './listini-vendita.component.html',
  styleUrls: ['./listini-vendita.component.css']
})
export class ListiniVenditaComponent implements OnInit {

  // ============= Costruttore ===============================================================

  constructor(private tokenService: CommonService<Token>,    
    private fileServer: CommonService<AttachmentDto>,
    private dataService:DataService,
    private documentService:CommonService<Documento>,
    public translate: TranslateService,
    private mimeTypeService:MimetypeService) { }
  //public activeModal: NgbActiveModal,
  documents: Documento[] = [];
  bgColors: any[] = ['mat-card-header-rose', 'mat-card-header-primary', 'mat-card-header-warning', 'mat-card-header-success', 'mat-card-header-info'];
  searchKey:any = "";
  locale:string;
  // ============= Inizializzazione e chiamate dirette  ======================================

  ngOnInit(): void {
    this.dataService.ComponentInput = 'LISTINIVENDITA.TITLE';
    this.initPageFunctions();
    this.locale = this.translate.currentLang;
  }

  // ============= Definizione funzioni ======================================================
  initPageFunctions = () => {
    this.getArcadocDocuments().then
    (
      (result) => {
        console.log("vetrina documents");
        console.dir(result);
        this.documents = result as Documento[];
        this.documents.forEach((x, i) => {
          x.isCollapsed = true;

          x.bg = 'mat-card-header-gray';//this.bgColors[this.getRandomBgIndex()];               
          x.active = 'titleTab';
        });

      },
      (error) => {
        console.dir(error);
      }
    );
  }

  getRandomBgIndex = () => {
    return Math.floor(Math.random() * Math.floor(this.bgColors.length - 1));
  }

  arcadocAuth() {
     // 27/01/2025 - funzione deprecata che non viene utilizzata
    // return new Promise((resolve, reject) => {
    //   let token: Token[] = [];
    //   let url = '/api/EportalWS/AuthToken';
    //   let input = new FormData();
    //   // Add your values in here
    //   // Eliminate credenziali in chiaro qui 08062021
    //   let arcadocToken = environment.arcadoc_token;
    //   input.append("token", arcadocToken);
    //   input.append("nopassword", "false");

    //   this.tokenService.SetBaseUrlArcaDoc(environment.arcadocBaseUrl);
    //   this.tokenService.postAuthArcadoc(url, input, false)
    //     .subscribe(result => {
    //       if (result != null) {
    //         resolve(result);
    //       }
    //     }, error => reject(error));

    // });
  }

  getArcadocDocuments = () =>{
    return new Promise((resolve, reject) => {
      let url = 'api/rest/LoadFilteredDocuments';

      let input = { idtipologia: 1, customtag: '',cultureInfo:this.translate.currentLang };
      this.documentService.postData(url, input, false).subscribe(result => {
        resolve(result);
  
      }, error =>{
        console.error('error on get documenti', error);
        reject(error);
      } );
    });
  }

  getArcadocDocumentsDirectlyFromArcadoc() {
    // 27/01/2025 - funzione deprecata che non viene utilizzata
    // return new Promise((resolve, reject) => {
    //   let mToken = localStorage.getItem("arcadocToken");
    //   let url = '/api/EportalWS/GetDocumenti';
    //   let input = new FormData();
    //   input.append("idtipologia", "1");
    //   input.append("maxdocumenti", "0");

    //   this.tokenService.SetBaseUrlArcaDoc(environment.arcadocBaseUrl);
    //   this.tokenService.postDataArcadoc(url, input, mToken)
    //     .subscribe(result => {
    //       if (result != null) {

    //         resolve(result);
    //       }
    //     }, error => reject(error));
    // });
  }

  getArcadocAttach(item:AttachmentDto,iddocumento) {

    let url = 'api/rest/GetAttachment';

    let params = { params: { idAllegato: item.idAllegato, idDocument: iddocumento, fileName: item.nomeFile, download: true } };
    this.fileServer.getData(url, params, false).toPromise().then(res => {

      console.log(res);
      let attachment: AttachmentDto = res as AttachmentDto;
      //this.getMimeType(attachment.data);

      //save(attachment.data, attachment.nomeFile);
      let ext = attachment.nomeFile.split('.').pop();

      //let   fileType = "application/"+ext + "; charset=utf-8";
      //const linkSource = 'data:'+ this.mimeTypeService.getMimeType(ext) +';base64,' + attachment.data;      
        //const linkSource = 'data:'+mimeTypes.getType(attachment.nomeFile) +';base64,' + attachment.data;
        const downloadLink = document.createElement("a");
        const fileName = attachment.nomeFile;

        // downloadLink.href = linkSource;
        // downloadLink.download = fileName;
        // downloadLink.click();
        this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext)).then(blob=>{
          let url = URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
      })
        
    });

  }

  dataURIToBlob = (dataURI, mimeString) => {

    return new Promise(resolve => {
      let binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      let result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })



  }


}
